import { formatMoney } from 'dashboard/helper/currency';

export const OPEN_ISSUED_QUOTE_STATUSES = ['sent', 'viewed'];

/**
 * Totals (excl. tax) for open quotes that have been sent to the customer.
 */
export function openIssuedQuoteTotals(quotes = []) {
  return quotes
    .filter(q => OPEN_ISSUED_QUOTE_STATUSES.includes(q?.status))
    .map(q => Number(q.total_excl_tax ?? q.totalExclTax ?? 0))
    .filter(n => !Number.isNaN(n));
}

/**
 * { min, max } from open issued quotes, or null when none.
 */
export function quotedPriceBounds(quotes = []) {
  const totals = openIssuedQuoteTotals(quotes);
  if (!totals.length) return null;
  return { min: Math.min(...totals), max: Math.max(...totals) };
}

/**
 * Format a single amount or min–max range. Same min/max → one number.
 */
export function formatQuotedPriceRange(min, max, currency, formatOptions = {}) {
  if (min == null || max == null) return null;
  const low = Number(min);
  const high = Number(max);
  if (Number.isNaN(low) || Number.isNaN(high)) return null;

  const lowLabel = formatMoney(low, currency, formatOptions);
  if (low === high) return lowLabel;

  const highLabel = formatMoney(high, currency, formatOptions);
  if (!lowLabel || !highLabel) return lowLabel || highLabel;
  return `${lowLabel} – ${highLabel}`;
}

/**
 * Card/list display amount: accepted → quoted range → fallback live total.
 */
export function resolveEventListPrice({
  acceptedTotal,
  quotedMin,
  quotedMax,
  fallbackTotal,
  currency,
  formatOptions = {},
} = {}) {
  if (acceptedTotal != null && acceptedTotal !== '') {
    return formatMoney(acceptedTotal, currency, formatOptions);
  }
  if (quotedMin != null && quotedMax != null) {
    return formatQuotedPriceRange(quotedMin, quotedMax, currency, formatOptions);
  }
  return formatMoney(fallbackTotal, currency, formatOptions);
}
